import React, { useEffect, useState } from "react";
import { Alert, Card, Col, FloatingLabel, Form, Row } from "react-bootstrap";
import QrReader from "react-qr-scanner";

const QrCodeScanner = () => {
  const [delay, setDelay] = useState(100);
  const [result, setResult] = useState("No result");
  const [error, setError] = useState("");
  const [devices, setDevices] = useState([]); // For storing available video input devices
  const [selectedDeviceId, setSelectedDeviceId] = useState(null); // To store the chosen camera

  useEffect(() => {
    // Get available video input devices
    const fetchDevices = async () => {
      try {
        const mediaDevices = await navigator.mediaDevices.enumerateDevices();
        const videoDevices = mediaDevices.filter(
          (device) => device.kind === "videoinput"
        );
        setDevices(videoDevices);
        if (videoDevices.length > 0) {
          setSelectedDeviceId(videoDevices[0].deviceId); // Default to the first camera
        }
      } catch (err) {
        console.error("Error fetching devices:", err);
      }
    };

    fetchDevices();
  }, []);

  const handleDeviceChange = (event) => {
    setSelectedDeviceId(event.target.value);
  };

  const handleScan = (data) => {
    if (data && data.text) {
      setResult(data.text);
    }
  };

  const handleError = (err) => {
    setError(err.message);
    console.error(err.message);
  };

  const previewStyle = {
    height: 240,
    width: 320,
  };

  return (
    <div>
      {error ? (
        <Alert variant="danger" dismissible>
          {" "}
          Error Scanning QR code. Due to {error}
        </Alert>
      ) : (
        ""
      )}
      <Row>
        <Col md="6" className="h-100 mb-3">
          {

            error ? "" :
              <QrReader
                className="mb-3"
                delay={delay}
                style={previewStyle}
                onError={handleError}
                onScan={handleScan}
              />

          }
          <FloatingLabel controlId="floatingSelect" label={error ? "No Camera Devices Found" : "Select Camera"}>
            <Form.Select
              id="camera-select"
              onChange={handleDeviceChange}
              value={selectedDeviceId || ""}
              aria-label="Choose Camera"
              disabled={devices.length === 0}>
              {devices.map((device, index) => (
                <option key={device.deviceId} value={device.deviceId}>
                  {device.label || `Camera ${index + 1}`}
                </option>
              ))}
            </Form.Select>
          </FloatingLabel>
        </Col>
        {
          error ? "" :
            <Col className="order-md-last order-first mb-3">
              <Card>
                <Card.Body>
                  <p>{result}</p>
                </Card.Body>
              </Card>
            </Col>
        }
      </Row>
    </div>
  );
};

export default QrCodeScanner;
